export default "__VITE_ASSET__BZnWN7FE__"